import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';
import { connect } from 'react-redux';
import { useMemo } from 'react';

import styles from './Judgment.module.scss';
import { IKnmErknmFormJudgmentSubjectData } from '../MainModule/interfaces/IKnmErknmFormJudgmentSubjectData';
import { ErknmJudgmentCancellationTableBody } from './ErknmJudgmentCancellationTableBody';

interface IErknmJudgmentCancellationInfoProps {
  watchOnly: boolean;
  judgmentCancellationItemId: string;
  judgmentCancellationItemName: string;
  judgmentSubjectData: IKnmErknmFormJudgmentSubjectData[] | undefined;
}

const ErknmJudgmentCancellationInfoWithoutStore = ({
  watchOnly,
  judgmentCancellationItemId,
  judgmentCancellationItemName,
  judgmentSubjectData,
}: IErknmJudgmentCancellationInfoProps) => {
  const secondColumnTitle = useMemo(() => {
    if (judgmentSubjectData?.some(item => item.cancellationActsAndDecisions?.length)) {
      return 'АКТ (РЕШЕНИЕ) КНМ';
    }

    return 'НАИМЕНОВАНИЕ ЛИЦА';
  }, [judgmentSubjectData]);

  return (
    <table width="100%" className={styles.Table}>
      <thead className={styles.CancellationTableHeader}>
        <tr>
          <th className={styles.CancellationTableInformationTitle}>№</th>
          <th className={styles.CancellationTableInformationTitle}>{secondColumnTitle}</th>
          <th className={styles.CancellationTableInformationTitle}>ПРИНЯТОЕ РАНЕЕ РЕШЕНИЕ</th>
          <th className={styles.CancellationTableInformationTitle}>ОТМЕНА ПРИНЯТОГО РЕШЕНИЯ</th>
          <th className={styles.CancellationTableInformationTitle}>ПОЯСНЕНИЕ</th>
        </tr>
      </thead>
      <tbody>
        <FieldArray name={`${judgmentCancellationItemName}.judgmentSubjectData`}>
          {({ fields }: FieldArrayRenderProps<IKnmErknmFormJudgmentSubjectData, HTMLElement>) => {
            if (!fields.length) {
              return null;
            }

            return fields.map((cancellationSubjectName, cancellationSubjectIndex) => {
              const cancellationSubjectValue: IKnmErknmFormJudgmentSubjectData =
                fields.value?.[cancellationSubjectIndex];
              const cancellationSubjectId = `${judgmentCancellationItemId}.judgmentSubjectData[${cancellationSubjectValue.listId}]`;

              return (
                <ErknmJudgmentCancellationTableBody
                  cancellationSubjectId={cancellationSubjectId}
                  cancellationSubjectName={cancellationSubjectName}
                  cancellationSubjectValue={cancellationSubjectValue}
                  watchOnly={watchOnly}
                  key={cancellationSubjectName}
                />
              );
            });
          }}
        </FieldArray>
      </tbody>
    </table>
  );
};

export const ErknmJudgmentCancellationInfo = connect(null)(ErknmJudgmentCancellationInfoWithoutStore);
